var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mt-10",attrs:{"flat":"","color":"#F9F9F9","max-width":"300"}},[_c('img',{attrs:{"width":"300px","src":_vm.src}}),_c('p',{staticClass:"text-center title"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }